export default __webpack_public_path__ + "navigation-examples-custom-server-v1-1200-3ada6be2be8d8b545a46a50916b6badf.webp";